<template>
  <div class="ArticleViewMp text-left" v-title data-title="详情">
    <ArticleDetailCom :fetchDetailApi="getArticleDetailMp" :detailId="$route.params.id" :type="$route.params.type" :isMp="true"/>
  </div>
</template>

<script>
import { getArticleDetailMp } from '@/network/NetworkAccessor';
import storage from '@/uitls/cacheUtil';
import ArticleDetailCom from './components/ArticleDetailCom.vue';

export default {
  name: 'ArticleViewMp',
  components: { ArticleDetailCom },
  data() {
    return {
      getArticleDetailMp,
      title: '文章预览',
      loading: false,
      detail: {
        id: '',
        title: '',
        author: '',
        content: '',
        cover: '',
        abstracts: '',
        type: '',
      },
    };
  },
  computed: {
  },
  methods: {
    back() {
      this.$router.back();
      // this.$router.push('/home');
    },
  },
  created() {
  },
  mounted() {
    const { initmsg = '' } = this.$route.query;
    if (initmsg) {
      this.$dialog.alert({
        message: initmsg,
      });
    }
  },
  beforeDestroy() {
    storage.local.remove('article_info');
  },
};
</script>

<style scoped>
  .ArticleViewMp {
  }
</style>
